/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';
import { useTheme, Grid } from '@material-ui/core';

import { Text, Title, Link } from 'components';
import { ROUTES } from '../constants';
import { ICustomTheme } from 'interfaces';

const NoMatch = (): JSX.Element => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();

  return (
    <React.Fragment>
      <Grid
        container
        item
        direction="column"
        alignContent="center"
        css={{ marginTop: 50 }}
      >
        <Title
          css={{ marginBottom: theme.spacing(4) }}
          position="center"
          label={t('auth.nomatch.title')}
          textCase="sentence"
        />

        <Text
          position="center"
          size="body1"
          isParagraph
          css={{ marginBottom: theme.spacing(4) }}
          text={t('auth.nomatch.description')}
        />

        <Grid container item justify="center">
          <Link
            color="primary"
            size="caption"
            text={t('auth.global.return_login')}
            to={ROUTES.HOME}
            weight="bold"
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default NoMatch;
